//section of an image for the 4:3 listing boxes, relative (0..1) to the image width/height
export interface ImageFrame {
    x: number;
    y: number;
    w: number;
    h: number;
}

//cover: the box is filled (the frame decides the visible part), contain: the whole frame/image is shown on a blurred background
export type ImageFit = 'cover' | 'contain';

export const LISTING_ASPECT_RATIO = 4 / 3;

//server format: frameX..frameH all null = no frame, fitMode 0 = cover, 1 = contain
export interface ImageFrameDTO {
    frameX?: number | null;
    frameY?: number | null;
    frameW?: number | null;
    frameH?: number | null;
    fitMode?: number;
}

export function frameFromDTO(dto: ImageFrameDTO | undefined): ImageFrame | null {
    if (dto?.frameX == null || dto.frameY == null || dto.frameW == null || dto.frameH == null) return null;
    return { x: dto.frameX, y: dto.frameY, w: dto.frameW, h: dto.frameH };
}

export function fitFromDTO(dto: ImageFrameDTO | undefined): ImageFit {
    return dto?.fitMode === 1 ? 'contain' : 'cover';
}

export function frameToDTO(frame: ImageFrame | null | undefined, fit: ImageFit | undefined): ImageFrameDTO {
    return {
        frameX: frame?.x ?? null,
        frameY: frame?.y ?? null,
        frameW: frame?.w ?? null,
        frameH: frame?.h ?? null,
        fitMode: fit === 'contain' ? 1 : 0
    };
}
